import React from 'react'
import { Helmet } from 'react-helmet'

import { ImageZoom } from 'shared/components/image-zoom'
import ParallaxSection from 'shared/components/parallax-section/parallax-section'

import imageData from './roof-data.json'
import './roof.scss'

const backgroundImage = require('assets/imgs/roof.jpg')

export function RoofPage() {
  return (
    <div className="roof">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Telhado Colonial</title>
        <meta
          name="description"
          content="Telhado colonial com estrutura metálica, maior segurança, maior durabilidade, mais leve,
          mais econômico, em alguns casos até 30% mais barato que madeira e com acabamento
          superior, pois a estrutura poderar ser pintada da cor desejada."
        />
        <meta property="og:url" content="https://www.execucao-engenharia.com.br/roof" />
        <link rel="canonical" href="https://www.execucao-engenharia.com.br/roof"></link>
      </Helmet>

      <section className="roof-section-parallax">
        <ParallaxSection title="TELHADOS" backgroundImage={`url(${backgroundImage})`} />
      </section>

      <section className="roof-section-text">
        <div className="container">
          <h3 className="roof-section-text-title" data-aos="fade-in">
            TELHADO COLONIAL COM ESTRUTURA METÁLICA
          </h3>
          <p data-aos="fade-in">
            Telhado colonial com estrutura metálica, maior segurança, maior durabilidade, mais leve,
            mais econômico, em alguns casos até 30% mais barato que madeira e com acabamento
            superior, pois a estrutura poderar ser pintada da cor desejada.
          </p>
        </div>
      </section>

      <section className="roof-grid-section">
        {imageData.map((image, index) => {
          return <ImageZoom key={index} imgUri={image.uri} />
        })}
      </section>
    </div>
  )
}
